import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { ShopService } from '@app/services/shops/shop.service';
import { OrderEditingService } from '../../order-editing.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
@Component({
  selector: 'order-editing-header',
  standalone: false,
  templateUrl: './order-editing-header.component.html',
  styleUrl: './order-editing-header.component.scss',
})
export class OrderEditingHeaderComponent implements OnInit {
  metricList = [];
  requiredScopes = OrderEditingService.requiredScopes;
  readonly shopCreated = inject(ShopService).shopCreatedSignal;
  updateBannerTitle = `To continue, you need to update the PDQ app on Shopify and grant ${OrderEditingService.requiredScopes.length} new access scopes:`;
  destroyRef = inject(DestroyRef);
  constructor(public orderEditingService: OrderEditingService) {}
  ngOnInit() {
    this.initMetricListener();
  }

  initMetricListener() {
    this.orderEditingService.metrics$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((metrics) => {
      this.metricList = Object.values(metrics);
    });
  }

  handleAppScopeUpdate() {
    window.open(this.orderEditingService.updateAppUrl(), '_blank');
  }
  loadMetrics(dates: { start: number; end: number }) {
    const startDate = new Date(dates.start).toISOString().slice(0, 10);
    const endDate = new Date(dates.end).toISOString().slice(0, 10);
    this.orderEditingService.loadMetrics(startDate, endDate);
  }
}
